export const RiskInterestRate = {
  ActiveEveAnalysis: {
    Data: {}
  }
}
